export default __webpack_public_path__ + "static/media/gallery_03.7211e719.jpg";